import { Link } from '@tanstack/react-router';
import { Component, type ErrorInfo, type ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error;
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-black text-white flex flex-col items-center justify-center px-6">
          <h1 className="text-6xl font-bold text-purple-500 mb-4">Oops!</h1>
          <p className="text-gray-400 text-lg mb-8 text-center max-w-md">
            Something went wrong. Please try again later.
          </p>
          <Link
            to="/"
            className="px-6 py-3 rounded-lg bg-purple-500 hover:bg-purple-600 text-white font-medium transition-colors"
          >
            Back to home
          </Link>
        </div>
      );
    }

    return this.props.children;
  }
}
